import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateViewport } from '../store/viewportSlice';

/**
 * Hook to watch for window resize and toggle the viewport and isMobile state.
 */
const useViewport = () => {
  const dispatch = useDispatch();
  const dispatchViewport = useCallback(
    () => dispatch(updateViewport()),
    [dispatch]
  );

  useEffect(() => {
    dispatchViewport();
    window.addEventListener('resize', dispatchViewport);
    return () => window.removeEventListener('resize', dispatchViewport);
  }, [dispatchViewport]);
};

export default useViewport;
